import { queryOptions, useQuery } from '@tanstack/react-query';
import ms from 'ms';
import api from '#/api';
import type { RequestOpts } from '#/api/api-types';
import queryClient from '#/api/queryClient';

export type UseCompanyInfoResponse = Awaited<ReturnType<typeof api.getCompany>>;

function getCompanyInfoQuery(opts: RequestOpts = {}) {
  const queryKey = ['getCompanyInfo'];
  return queryOptions({
    queryKey,
    queryFn: ({ signal }) => {
      return api.getCompany({
        ...opts,
        signal,
      });
    },
    retry: true,
    staleTime: ms('5m'),
    gcTime: ms('10m'),
    initialDataUpdatedAt: queryClient.getQueryState(queryKey)?.dataUpdatedAt,
  });
}

export async function fetchCompanyInfoQuery(opts: RequestOpts = {}) {
  return queryClient.fetchQuery(getCompanyInfoQuery(opts));
}

function useCompanyInfo(
  options: Omit<ReturnType<typeof getCompanyInfoQuery>, 'queryKey'> = {},
) {
  const query = getCompanyInfoQuery();
  return useQuery({
    ...query,
    ...options,
  });
}

export default useCompanyInfo;
